import i18n from "@/plugins/vue-i18n";

const SignUp = () => import(/* webpackChunkName: "auth" */ "@/views/agent/auth/signUp");

const signup = [
  {
    path: "/signup",
    name: "SignUp",
    component: SignUp,
    meta: {
      title: i18n.t("title.auth.signUp"),
    },
  },
];

export default signup;
